import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const Hojin = props => {
  return <Dropdown.Static kubunKey='hojin' {...props} />
}
